import { TextField } from '@mui/material'

function RadiusInput({ radius, onChange }: { radius: number; onChange: (event: number) => void }) {
  return (
    <TextField
      value={radius}
      onChange={(event) => onChange(Number(event.target.value))}
      inputProps={{
        step: 1,
        min: 1,
        max: 100,
        type: 'number',
        'aria-labelledby': 'input-slider'
      }}
    />
  )
}

export default RadiusInput
